// extracted by mini-css-extract-plugin
module.exports = {"container":"page_nav_scroll_handler-module__container--1l3QW","bottom":"page_nav_scroll_handler-module__bottom--tOmVe"};